import React from 'react';
import Tooltip from 'react-tooltip-lite';

const CategoryMenu = ({ categories, handleClick, activeCategory }) => {
  return (
    <section className="category-menu">
      {categories.map((category, i) => (
        <Tooltip
          content={category.title}
          className="icon-wrapper"
          key={category.id}
          direction="left"
          hoverDelay={500}
          padding="5px"
          arrowSize={8}
        >
          <div
            className={
              activeCategory === i ? 'category-icon active' : 'category-icon'
            }
            onClick={() => handleClick(i)}
          ></div>
        </Tooltip>
      ))}
    </section>
  );
};

export default CategoryMenu;
